import React from 'react';

/**
 * Componente para lidar com imagens de marca de forma segura.
 * Se a imagem falhar ou não existir, ele não "quebra" o layout.
 */
const BrandImage = ({ envKey, defaultAsset, alt, className, style }) => {
  // Busca o caminho no .env, se não existir, usa o asset padrão
  const src = process.env[envKey] || defaultAsset;

  // Se não houver nem no env nem no default, podemos retornar um ícone
  if (!src) return <i className="bi bi-image text-muted"></i>;

  return (
    <img 
      src={src} 
      alt={alt || "Imagem do Sistema"} 
      className={className}
      style={{ 
        objectFit: 'contain', 
        ...style 
      }}
      // Caso o arquivo físico não exista no servidor, evita o ícone de "imagem quebrada"
      onError={(e) => {
        e.target.style.display = 'none'; 
      }}
    />
  );
};

export default BrandImage;